<template>
  <SkipLink />
  <NavMenu />
  <main id="main-content" tabindex="-1">
    <router-view :key="$route.path" />
  </main>
  <Footer
    v-if="
      $route.path != '/onze-bevindingen/nieuwsbrief' &&
      $route.path != '/nieuwsbericht' &&
      $route.path != '/regeling'
    "
  />
</template>

<script>
import { onMounted } from "vue";
import NavMenu from "./components/NavMenu.vue";
import Footer from "./views/Footer.vue";
import SkipLink from "./components/global-components/SkipLink.vue";
export default {
  name: "App",
  components: {
    SkipLink,
    NavMenu,
    Footer,
  },
  setup() {
    onMounted(() => {
      document.documentElement.lang = "nl";
    });
    return {};
  },
};
</script>
